import React from 'react';
import styles from './NewsCard.module.css';

const TAG_COLORS = {
  Announcement: '#C8A75B',
  Balance: '#5B7EC8',
  Event: '#4A8C5C',
  Update: '#8B6B2D',
};

function formatDate(dateStr) {
  return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export default function NewsCard({ date, tag, title, summary }) {
  const color = TAG_COLORS[tag] || '#C8A75B';
  return (
    <article className={styles.card}>
      <div className={styles.meta}>
        <span className={styles.tag} style={{ color, borderColor: color }}>{tag}</span>
        <time className={styles.date} dateTime={date}>{formatDate(date)}</time>
      </div>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.summary}>{summary}</p>
    </article>
  );
}
